import { initHandler } from './handler.js';
import { initRender } from './render.js';
import { initDuoCodeApply } from './duo-code-apply.js';
import { initPromoCodeApply } from './promo-code-apply.js';

export function initPayment() {
	initHandler();
	initRender();
	initDuoCodeApply();
	initPromoCodeApply();
}
